<template>
  <div class="cell total" :class="'cell__' + column">
    <template v-if="column === 'worker'"> Итого за месяц </template>

    <template v-if="column === 'days'">
      <div class="timeline">
        <div v-for="day in stats.days" :key="day.key" class="day">
          {{ Math.floor((day.totalTimeMin / 60) * 10) / 10 }}
        </div>
      </div>
    </template>

    <template v-if="column === 'totalShifts'">
      <div class="shifts">
        {{ stats.dayShiftsCount + stats.nightShiftsCount }}
      </div>
    </template>

    <template v-if="column === 'workTime'">
      {{ formatTime(stats.totalTimeMin) }}
    </template>

    <template v-if="column === 'compensation'"> 0 </template>

    <template v-if="column === 'load'"> 0 </template>

    <template v-if="column === 'salary'">
      {{ Math.round(stats.salary).toLocaleString() }}
    </template>

    <template v-if="column === 'salaryMainPart'">
      {{ (Math.round(stats.salaryMain || 0)).toLocaleString() }}
    </template>

    <template v-if="column === 'excessPremium'"> 0 </template>

    <template v-if="column === 'Depreciation'"> 0 </template>

    <template v-if="column === 'premium'"> 0 </template>

    <template v-if="column === 'fine'"> 0 </template>

    <template v-if="column === 'deductions'"> 0 </template>

    <template v-if="column === 'totalAccrued'"> 0 </template>
  </div>
</template>

<script>
export default {
  props: ["column", "stats"],

  methods: {
    formatTime(min = 0) {
      let h = Math.floor(min / 60);
      let m = min % 60;

      h = `${h}`.padStart(2, "0");
      m = `${m}`.padStart(2, "0");

      return `${h}:${m}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/vars";
.cell {
  display: flex;
}
.timeline {
  display: flex;
  margin-top: -1px;
  margin-bottom: -1px;
  margin-right: -1px;
}
.day {
  width: 24px;
  flex-shrink: 0;
  cursor: pointer;
  border: 1px solid #dfe4ef;
  margin-left: -1px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
